import styled from 'styled-components'
import { ReactComponent as ErrorIcon } from '../../../../assets/svg/x-alert.svg'
import { ReactComponent as InfoIcon } from '../../../../assets/svg/info.svg'
import { theme } from '@provi/provi-components'

export const PixErrorContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  width: auto;
  max-width: 908px;
  height: auto;
  max-height: 72px;

  background-color: #f7d4d4;
  border-radius: 6px;
  padding: 12px 16px;
`

export const PixSuccessContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;

  width: auto;
  max-width: 908px;
  height: auto;
  max-height: 72px;

  background-color: #cceeff;
  border-radius: 6px;
  padding: 12px 16px;
`

export const ErrorIconStyled = styled(ErrorIcon)`
  margin-top: 2px;
  flex-shrink: 0;
`
export const InfoIconStyled = styled(InfoIcon)`
  margin-top: 2px;
  flex-shrink: 0;
`
export const PixValueSubTitle = styled.h2`
  display: flex;
  gap: 4px;
  font-family: 'Montserrat', sans-serif;
  flex-direction: row;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  color: #575757;
  align-items: center;
`

export const SelectorContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`

export const StyledLabel = styled.label`
  padding: 8px 16px;
  border: 1px solid ${({ isSelected }) => (isSelected ? theme.colors.primary : '#ccc')};
  border-radius: 6px;
  background: ${({ isSelected }) => (isSelected ? theme.colors.primaryLight : '#fff')};
  color: ${({ isSelected }) => (isSelected ? theme.colors.primaryDark : '#333')};
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    border-color: ${theme.colors.primary};
  }
`
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 600px;
`

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 15px;

  label {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  input {
    margin: 0;
  }
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PixKeySubTitle = styled.div`
  font-weight: 400;
  color: #666666;
`
export const Select = styled.select`
  font-family: 'Montserrat', sans-serif;
  width: 140px;
  height: 40px;
  gap: 8px;
  border-radius: 6px;
  font-size: 16px;
  padding: 8px 32px 8px 16px;
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
  }
`

export const Input = styled.input`
  width: auto;
  height: auto;
  gap: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  padding: 8px 16px;
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
  }
`
export const SelectInputWrapper = styled.div`
  display: flex;
  gap: 16px;
`

export const UpdateButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 102px;
  height: 40px;

  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  background-color: #006eab;
  color: white;
  cursor: pointer;

  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;

  margin-bottom: 20px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`
export const Small = styled.small`
  color: ${theme.colors.red100};
`
